import { notify } from 'utils/reduxUtils';

export const types = {
  DELETE_EMAIL_TEMPLATE_ERROR:
    'settings/digitalQuote/DELETE_EMAIL_TEMPLATE_ERROR',
  DELETE_EMAIL_TEMPLATE_REQUEST:
    'settings/digitalQuote/DELETE_EMAIL_TEMPLATE_REQUEST',
  DELETE_EMAIL_TEMPLATE_SUCCESS:
    'settings/digitalQuote/DELETE_EMAIL_TEMPLATE_SUCCESS',
  EMAIL_TEMPLATE_MODAL_CLOSE:
    'settings/digitalQuote/EMAIL_TEMPLATE_MODAL_CLOSE',
  EMAIL_TEMPLATE_MODAL_OPEN: 'settings/digitalQuote/EMAIL_TEMPLATE_MODAL_OPEN',
  FETCH_DEFAULT_EMAIL_TEMPLATES_SUCCESS:
    'settings/digitalQuote/FETCH_DEFAULT_EMAIL_TEMPLATES_SUCCESS',
  FETCH_EMAIL_TEMPLATES_SUCCESS:
    'settings/digitalQuote/FETCH_EMAIL_TEMPLATES_SUCCESS',
  UPDATE_OR_CREATE_EMAIL_TEMPLATE_ERROR:
    'settings/digitalQuote/UPDATE_OR_CREATE_EMAIL_TEMPLATE_ERROR',
  UPDATE_OR_CREATE_EMAIL_TEMPLATE_REQUEST:
    'settings/digitalQuote/UPDATE_OR_CREATE_EMAIL_TEMPLATE_REQUEST',
  UPDATE_OR_CREATE_EMAIL_TEMPLATE_SUCCESS:
    'settings/digitalQuote/UPDATE_OR_CREATE_EMAIL_TEMPLATE_SUCCESS',
};

export const deleteEmailTemplate = {
  error: notify(
    (error) => ({
      type: types.DELETE_EMAIL_TEMPLATE_ERROR,
      payload: error,
    }),
    "Can't delete email template",
  ),
  request: ({ templateId }) => ({
    type: types.DELETE_EMAIL_TEMPLATE_REQUEST,
    payload: { templateId },
  }),
  success: ({ templateId }) => ({
    type: types.DELETE_EMAIL_TEMPLATE_SUCCESS,
    payload: { templateId },
  }),
};

export const emailTemplateModal = {
  close: () => ({
    type: types.EMAIL_TEMPLATE_MODAL_CLOSE,
  }),
  open: ({ templateId, templateType }) => ({
    type: types.EMAIL_TEMPLATE_MODAL_OPEN,
    payload: { templateId, templateType },
  }),
};

export const fetchDefaultEmailTemplates = {
  success: ({ defaultEmailTemplates }) => ({
    type: types.FETCH_DEFAULT_EMAIL_TEMPLATES_SUCCESS,
    payload: { defaultEmailTemplates },
  }),
};

export const fetchEmailTemplates = {
  success: ({ emailTemplates }) => ({
    type: types.FETCH_EMAIL_TEMPLATES_SUCCESS,
    payload: { emailTemplates },
  }),
};

export const updateOrCreateEmailTemplate = {
  error: notify(
    (error) => ({
      type: types.UPDATE_OR_CREATE_EMAIL_TEMPLATE_ERROR,
      payload: error,
    }),
    'Failed to save email template',
  ),
  request: ({
    customSubject,
    id,
    template,
    templateType,
    title,
    isDefault,
  }) => ({
    type: types.UPDATE_OR_CREATE_EMAIL_TEMPLATE_REQUEST,
    payload: { customSubject, id, template, templateType, title, isDefault },
  }),
  success: ({ emailTemplate }) => ({
    type: types.UPDATE_OR_CREATE_EMAIL_TEMPLATE_SUCCESS,
    payload: { emailTemplate },
  }),
};
